import React from 'react';

import {
  Box,
  Stack,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../common/dialog/BootstrapDialog';
import DetailTemplate from '../../common/template/DetailTemplate';
import OrderBookSummary from './OrderBookSummary';
import OrderBookFormContainer from '../../../containers/chancemng/obtainorder/OrderBookFormContainer';
import OrderProductListContainer from '../../../containers/chancemng/obtainorder/OrderProductListContainer';
import OrderBookApprovalContainer from '../../../containers/chancemng/obtainorder/OrderBookApprovalContainer';
import OrderBookApprovalFormContainer from '../../../containers/chancemng/obtainorder/OrderBookApprovalFormContainer';
import ApprovalFormContainer from '../../../containers/chancemng/approval/ApprovalFormContainer';
import OrderBookInfoContainer from '../../../containers/chancemng/obtainorder/OrderBookInfoContainer';
import SalesProfitFormContainer from '../../../containers/chancemng/obtainorder/SalesProfitFormContainer';
import SalesProfitInfoContainer from '../../../containers/chancemng/obtainorder/SalesProfitInfoContainer';
import OrderBookFileListContainer from '../../../containers/chancemng/obtainorder/OrderBookFileListContainer';
import { getNumberComma } from '../../../utils/numberUtils';

const OrderBookModal = ({
  chance,
  apprUuid,
  setApprUuid,
  approvalList,
  user,
  type,
  open,
  handleClose,
  formik,
  orderInfo,
  scollToRef,
  onDeleteApproval,
}) => {
  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      fullScreen
      fullWidth={true}
    >
      <BootstrapDialogTitle onClose={handleClose}>
        수주품의서
        {type === 'edit' && orderInfo && orderInfo?.ordYn === 'S' && (
          <ApprovalFormContainer
            docuCd={orderInfo?.roUuid}
            user={user}
            type="order"
          />
        )}
      </BootstrapDialogTitle>

      <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
        <DialogContent
          dividers
          sx={{
            height: '80vh',
            overflowY: 'auto',
          }}
        >
          {orderInfo?.ordYn === 'S' && user?.usrUuid === orderInfo?.crtUsr && (
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{ my: 1 }}
            >
              <Button
                variant="contained"
                color="error"
                onClick={onDeleteApproval}
              >
                결재 삭제
              </Button>
            </Stack>
          )}
          {type === 'edit' && (
            <DetailTemplate title="내역">
              <OrderBookSummary
                orderInfo={orderInfo}
                approvalList={approvalList}
              />
            </DetailTemplate>
          )}

          <div ref={scollToRef}></div>
          <DetailTemplate title="기본사항">
            {type === 'edit' && orderInfo?.ordYn !== 'S' ? (
              <OrderBookInfoContainer orderInfo={orderInfo} chance={chance} />
            ) : (
              <OrderBookFormContainer
                type={type}
                formik={formik}
                chance={chance}
                orderInfo={orderInfo}
              />
            )}
          </DetailTemplate>

          {type === 'edit' && (
            <DetailTemplate title="수주품의서 파일 리스트">
              <OrderBookFileListContainer orderInfo={orderInfo} />
            </DetailTemplate>
          )}

          <DetailTemplate title={`최종 매출 이익 (내부거래 포함)`}>
            {type === 'edit' && orderInfo?.ordYn !== 'S' ? (
              <SalesProfitInfoContainer orderInfo={orderInfo} chance={chance} />
            ) : (
              <SalesProfitFormContainer
                formik={formik}
                chance={chance}
                orderInfo={orderInfo}
              />
            )}
          </DetailTemplate>

          {(type === 'add' ||
            (type === 'edit' &&
              orderInfo?.crtUsr === user?.usrUuid &&
              !approvalList)) && (
            <DetailTemplate title="결재선 확인">
              <OrderBookApprovalFormContainer
                type={type}
                apprUuid={apprUuid}
                setApprUuid={setApprUuid}
              />
            </DetailTemplate>
          )}

          {type === 'edit' && (
            <DetailTemplate title="결재 내역">
              <OrderBookApprovalContainer approvalList={approvalList} />
            </DetailTemplate>
          )}

          <DetailTemplate title="원가 산출 내역">
            <OrderProductListContainer />
          </DetailTemplate>
        </DialogContent>
        <DialogActions>
          {type === 'add' ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                m: 1,
              }}
            >
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={formik.isSubmitting}
              >
                수주품의서 저장
              </Button>
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',
                m: 1,
              }}
            >
              <Box>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  disabled={orderInfo?.ordYn !== 'S' || formik.isSubmitting}
                >
                  수주품의서 저장
                </Button>
              </Box>
            </Box>
          )}
        </DialogActions>
      </form>
    </BootstrapDialog>
  );
};

export default OrderBookModal;
